
import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { Badge } from '@/components/ui/badge';
import { createDeviceIcon } from './iconUtils';
import { Device } from './types';

interface DeviceMarkerProps {
  device: Device;
  onSelectDevice?: (deviceId: string, deviceType: 'smartMeter' | 'gateway' | 'voltageRegulator', deviceData?: Device) => void;
}

const DeviceMarker: React.FC<DeviceMarkerProps> = ({ device, onSelectDevice }) => {
  const position: [number, number] = [device.location.lat, device.location.lng];
  const icon = createDeviceIcon(device.type, device.status);
  
  const handleViewDetails = () => {
    if (onSelectDevice) {
      // Pass the device data along with the ID and type
      onSelectDevice(device.id, device.type as 'smartMeter' | 'gateway' | 'voltageRegulator', device);
    }
  };
  
  const statusBadgeColor = () => {
    switch (device.status) {
      case 'Healthy': return 'bg-green-500';
      case 'Warning': return 'bg-yellow-500';
      case 'Critical': return 'bg-red-500';
      case 'Inactive': return 'bg-gray-500';
      case 'Offline': return 'bg-gray-700';
      default: return 'bg-gray-500';
    }
  };
  
  return (
    <Marker position={position} icon={icon}>
      <Popup>
        <div className="p-1 device-popup">
          <div className="flex items-start justify-between mb-2">
            <h3 className="font-semibold text-sm">{device.name}</h3>
            <Badge className={statusBadgeColor()}>
              {device.status}
            </Badge>
          </div>
          
          <div className="text-xs text-gray-600 mb-1">ID: {device.id}</div>
          <div className="text-xs text-gray-600 mb-1">Type: {device.type}</div>
          
          <div className="text-xs text-gray-600 mb-2">
            {device.location.address}
          </div>
          
          <div className="text-xs text-gray-600 mb-2">
            Department: {device.department}
          </div>
          
          <div className="text-xs text-gray-600 mb-3">
            Last Active: {new Date(device.lastActive || '').toLocaleString()}
          </div>
          
          <button 
            className="w-full text-xs bg-blue-500 hover:bg-blue-600 text-white py-1 px-2 rounded"
            onClick={handleViewDetails}
          >
            View Details
          </button>
        </div>
      </Popup>
    </Marker>
  );
};

export default DeviceMarker;
